import BackgroundArrow from "../../component/BackgroundArrow/BackgroundArrow";
function Portfolio() {
  return (
    <div>
      <div className="font-extrabold text-3xl">MES PROJETS</div>
      <div className="mt-8 flex items-center flex-row gap-12 flex-wrap lg:flex-nowrap lg:gap-20 p-5">
        <BackgroundArrow />
      </div>
    </div>
  );
}
export default Portfolio;
